// This is a function because we want new state every test.
// If we don't do this, the state is being mutated leading to flaky tests.
export const state = () => ({
  dashboardWidgetsMap: {},
  // Stores currently displayed dashboard and widgets present in it
  currentDashboard: null,
  currentWidgets: {}
});
